/* Setinha dos carrosseis no celular.

   Toda fileira que vira carrossel (cards de produto, categorias, kits,
   passos, modos de preparo) ganha um botao redondo com seta na borda
   direita. Tocar avanca um card. A seta some quando a fileira chega ao
   fim, quando tudo cabe na tela e no desktop.

   O script embrulha a fileira num <div class="artisan-rolagem"> para ter
   onde apoiar a seta; nenhuma classe da fileira muda. */
(function () {
  var SELETOR = [
    '.artisan-passos',
    '.artisan-grade:not([data-grade-colecao])',
    '.artisan-cats__grade',
    '.artisan-vitrine__kits',
    '.artisan-kits__grade',
    '.artisan-prod__modos'
  ].join(',');
  var celular = window.matchMedia('(max-width: 768px)');
  var SETA = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function montar(fila) {
    if (fila.dataset.rolagem) return;
    fila.dataset.rolagem = '1';

    var caixa = document.createElement('div');
    caixa.className = 'artisan-rolagem';
    fila.parentNode.insertBefore(caixa, fila);
    caixa.appendChild(fila);

    var seta = document.createElement('button');
    seta.type = 'button';
    seta.className = 'artisan-rolagem__seta';
    seta.setAttribute('aria-label', 'Ver o proximo');
    seta.innerHTML = SETA;
    caixa.appendChild(seta);

    function passo() {
      var primeiro = fila.children[0];
      return primeiro ? primeiro.getBoundingClientRect().width + 12 : fila.clientWidth * 0.7;
    }
    function atualizar() {
      var rola = fila.scrollWidth > fila.clientWidth + 4;
      var fim = fila.scrollLeft + fila.clientWidth >= fila.scrollWidth - 4;
      caixa.classList.toggle('artisan-rolagem--fim', !celular.matches || !rola || fim);
    }

    seta.addEventListener('click', function () {
      fila.scrollBy({ left: passo(), behavior: 'smooth' });
    });
    fila.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', atualizar);
    atualizar();
    setTimeout(atualizar, 800);
  }

  function iniciar() {
    document.querySelectorAll(SELETOR).forEach(montar);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  /* Secoes que o editor do tema recarrega ganham a seta de novo. */
  document.addEventListener('shopify:section:load', iniciar);
})();
